import { render, staticRenderFns } from "./10_ap_claves_moneda.vue?vue&type=template&id=a77cafa2&scoped=true&"
import script from "./10_ap_claves_moneda.vue?vue&type=script&lang=js&"
export * from "./10_ap_claves_moneda.vue?vue&type=script&lang=js&"
import style0 from "./10_ap_claves_moneda.vue?vue&type=style&index=0&id=a77cafa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77cafa2",
  null
  
)

export default component.exports